import {
    USER_CREATE_REQUEST, USER_CREATE_SUCCESS, USER_CREATE_FAILURE,
    USER_GET_REQUEST, USER_GET_SUCCESS, USER_GET_FAILURE,
    USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS, USER_UPDATE_FAILURE,
    CHECK_EMAIL_EXISTS_REQUEST, CHECK_EMAIL_EXISTS_SUCCESS, CHECK_EMAIL_EXISTS_FAILURE,
} from '../constants/actionconstants';
import { ROUTE_HOME } from '../constants/routeconstants';
import client from '../utils/ajax/client';
import { push } from 'react-router-redux';
import * as GlobalErrorActions from '../actions/globalerror';
import { setForceAuthRecheck } from '../actions/auth';

export function userCreate(userProfile, onSuccess = null, redirectTo = ROUTE_HOME) {
    return (dispatch) => {
        dispatch(userCreateRequest());
        client({
            method: 'POST',
            path: '/api/user',
            entity: userProfile,
            params: {
                autoLogin: true
            },
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(userCreateSuccess(response.entity.username));
            if (redirectTo != null) dispatch(push(redirectTo)); // dispatch(push(ROUTE_SIGNIN));
            dispatch(setForceAuthRecheck(true)); // <- in case browser was already logged in as a different user, force rechecking with the server who is logged in.
            if (onSuccess != null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occurred during sign up - please try again later.", response));
            dispatch(userCreateFailure(response));
        });
    }
}

function userCreateRequest() {
    return {
        type : USER_CREATE_REQUEST
    }
}

function userCreateSuccess(username) {
    return {
        type : USER_CREATE_SUCCESS,
        payload : {
            username : username
        }
    }
}

function userCreateFailure(error) {
    return {
        type : USER_CREATE_FAILURE,
        payload : {
            status: error.response.status,
            statusText: error.response.statusText
        }
    }
}


export function updateUser(id, userProfile, onSuccess = null) {
    return function (dispatch) {
        dispatch(updateUserRequest());
        client({
            method: 'PUT',
            path: '/api/user/' + id,
            entity: userProfile,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateUserSuccess(response));
            if (onSuccess != null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("An error occured while updating the user", response));
            dispatch(updateUserFailure(response));
        });
    };
}

function updateUserRequest() {
    return {
        type: USER_UPDATE_REQUEST
    };
}

function updateUserSuccess(response) {
    return {
        payload: response.entity,
        type: USER_UPDATE_SUCCESS
    };
}

function updateUserFailure(response) {
    return {
        type: USER_UPDATE_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

export function checkEmailExists(email, excludedUserId = null, onSuccess = null) {
    return function (dispatch) {
        dispatch(checkEmailExistsRequest());
        client({
            method: 'GET',
            path: '/api/user/check-exists',
            params: {
                email: email,
                exclude: excludedUserId
            }
        }).then(response => {
            dispatch(checkEmailExistsSuccess(response, email));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            //dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Error checking username with server", response));
            dispatch(checkEmailExistsFailure(response));
        });
    };
}

function checkEmailExistsRequest() {
    return {
        type: CHECK_EMAIL_EXISTS_REQUEST
    };
}

function checkEmailExistsSuccess(response, email) {
    return {
        type: CHECK_EMAIL_EXISTS_SUCCESS,
        payload: {
            name: email,
            exists: response.entity.exists
        }
    };
}

function checkEmailExistsFailure(response) {
    return {
        type: CHECK_EMAIL_EXISTS_FAILURE,
        payload: {
            status: response.status.code,
            statusText: response.entity
        }
    };
}

export function getUser(userId, includeImages = false) {
    return (dispatch) => {
        dispatch(getUserRequest());
        client({
            method: 'GET',
            path: '/api/user/'+userId,
            params: {
                includeImages: includeImages
            }
        }).then(response => {
            dispatch(getUserSuccess(response.entity));
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Error retrieving user", response));
            dispatch(getUserFailure(response));
        });
    }
}

function getUserRequest() {
    return {
        type : USER_GET_REQUEST
    }
}

function getUserSuccess(user) {
    return {
        type : USER_GET_SUCCESS,
        payload : user
    }
}

function getUserFailure(error) {
    return {
        type : USER_GET_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


// WEBPACK FOOTER //
// ./src/client/src/actions/user.js